import { GatsbyImage, StaticImage } from "gatsby-plugin-image";

import { AspectRatio } from "@vinomofo/components";

import { StorefrontImage } from "../../types";

export interface RelativeSizeImageProps {
  name?: string;
  image: StorefrontImage;
  ratio?: Array<number> | number;
  height?: string;
  opacity?: number;
  overflow?: string;
  secret?: boolean;
  isSmallBottle?: boolean;
}

export const RelativeSizeImage = ({
  name,
  image,
  ratio = 1440 / 725,
  height = "100%",
  opacity = 1,
  overflow = "hidden",
  secret,
  isSmallBottle = false,
  ...rest
}: RelativeSizeImageProps): JSX.Element => {
  return (
    <AspectRatio ratio={ratio} opacity={opacity} overflow={overflow}>
      {image ? (
        <GatsbyImage
          image={image}
          style={{
            width: "100%",
            height: "100%",
            textAlign: "center",
            overflow: `${overflow}`,
          }}
          imgStyle={{
            objectFit: "contain",
            top: "auto",
            bottom: "0",
            width: "100%",
            height: isSmallBottle ? "120%" : height,
          }}
          {...rest}
          alt={name}
        />
      ) : secret ? (
        <StaticImage
          src="../../images/mystery-bottle-full.png"
          style={{
            width: "100%",
            height: "100%",
            textAlign: "center",
            overflow: `${overflow}`,
          }}
          imgStyle={{
            objectFit: "contain",
            top: "auto",
            bottom: "0",
            width: "100%",
            height: height,
          }}
          alt=""
        />
      ) : (
        <StaticImage
          src="../../images/place-holders/relative-size-bottle-red-bordeaux.png"
          style={{
            width: "100%",
            height: "100%",
            textAlign: "center",
            overflow: `${overflow}`,
          }}
          imgStyle={{
            objectFit: "contain",
            top: "auto",
            bottom: "0",
            width: "100%",
            height: height,
          }}
          alt=""
        />
      )}
    </AspectRatio>
  );
};
